---
nb:
  fall_lease:
    accumulated: Akkumulert
    actions: Handlinger
    active: Aktiv
    approve: Vedta
    approve_prompt: Du skriver nå over eksisterende falleieberegning. Er du sikker?
    approved: Godkjent
    averaging_interval: Gjennomsnittsintervall
    back: Tilbake
    calculation_interval: Beregningsintervall
    code_list: Kodeliste
    computable: Beregnbar
    computable_computing: Beregning pågår
    computable_false: Beregning mislyktes. Vennligst sjekk om alle parametre er korrekte, eller kontakt Kaia.
    computable_true: Beregningen fungerer som normalt
    computable_unknown: Ikke beregnet
    computation_state: Beregningsstatus
    compute: Beregne
    compute_all_prompt: |-
      Du er i ferd med å beregne alle høstleieavtaler.
      Oppgaven vil ta 1-5 minutter å fullføre.
      Er du sikker?
    compute_current_year: Beregn inneværende år
    computing_job_status:
      in_queue: I kø
      not_found: Ikke funnet, klikk for å prøve på nytt
      running: Kjører
    computing_status: Beregningsstatus
    confirm_code_list_clear: Du kommer til å tømme listen over kontokoder. Vennligst bekreft.
    contract_details: Kontraktdetaljer
    contract_id: Kontrakt ID
    contract_nr: Kontrakt \#
    contract_structure: Kontraktsstruktur
    contract_type: Type kontrakt
    counterpart: Kontraktspart
    counterpart_fields:
      add: Legg til motpart
      fall_lease: Estimert påløpt falleie i angitt år
      informational_text_accuracy: Unøyaktigheter og feil vil forekomme både for inneværende og historiske år.
      informational_text_test: Dette er en testversjon.
      landowner: Grunneier
      landowner_error: En grunneier må velges
      share: Andel[%]
      share_error: Total andel skal ikke overstige 100%
      show_landowner_info: Informasjon om falleie grunneier
    currency: Valuta
    disapprove: Ikke godkjenn
    download_xlsx: Last ned (xlsx)
    elcert: Elsertifikater
    elcert_codes: Elsertifikat-koder
    elcert_owners: Elcert-innehavere
    elcert_share: Rate for elsertifikater
    end_date: Sluttdato
    fall_lease: Falleie
    fall_lease_contract_details: Falleie kontraktsdetaljer
    fall_lease_contracts: Falleiekontrakter
    fall_lease_summary: Oppsummering falleie
    filter_data: Filtrer data
    fixed_price: Leieavgift for land
    goos: GoOs
    goos_codes: GoOs-koder
    goos_owners: GoOs-innehavere
    goos_share: Rate for grønne obligasjoner (GoOs)
    gross: Brutto
    kpi_adjustment: KPI-justering
    kpi_end_date_type: KPI sluttdato
    kpi_ref_date: KPI referansedato
    loading_please_wait: Laster... Vennligst vent
    lock: Lås
    lock_all: Lås alle år
    lock_prompt: Du er nå i ferd med å låse parameterne. Er du sikker på at du vil låse dem?
    lock_prompt_false: Du låser nå opp parameterne. Er du sikker på at du vil låse opp?
    lock_prompt_true: Du låser nå parameterne. Er du sikker på at du vil låse?
    locked: Låst
    min_price: Minimums falleienivå
    model_rate: Modellrate - Inntekter fra strømsalg
    model_rate_hint: 'For eksempel: 5'
    model_type: Beregningsmodell
    net: Brutto med kostnader
    none: Ingen
    payment_dates: Utbetalingsdatoer
    payment_interval: Betalingsintervall
    power_plant_name: Kraftverksnavn
    pp_revenues_costs: Inntekter og kostnader for kraftverket
    rate_structure: Falleiestruktur
    remove_all: Fjern alle år
    remove_all_prompt: |-
      Du er i ferd med å FJERNE ALLE falleieavtaler for kraftverk.
      Er du sikker?
    revenue: Inntekt
    revenue_codes: Inntektskoder
    revenue_owners: Inntektsinnehavere
    save: Lagre
    save_all_years: Lagre alle år
    save_and_compute: Lagre og beregne
    save_compute_all: Beregn alle år
    select_cols_show: Velg hvilke kolonner som skal vises
    select_columns_to_show: Velg kolonner som skal vises
    start_date: Startdato
    threshold_method: Terskelmetode
    threshold_rate: Terskelrate
    threshold_rate_hint: 'For eksempel: 10, 15, 25'
    threshold_type: Terskeltype
    threshold_value: Terskelverdi
    threshold_value_hint: 'For eksempel: 0, 16000, 50000'
    total: Totalt
    total_costs: Totale kostnader
    total_costs_codes: Totale kostnader-koder
    total_costs_owners: Kostnadsinnehavere
    total_fall_leases: Total falleie
    unlock: Lås opp
    unlock_all: Lås opp alle år
    websocket_connected: Koblet til server
    websocket_disconnected: Koblet fra server
    xledger_api:
      insufficient_credits: Utilstrekkelig XLedger kreditt, tilbakestilles kl %{reset_at}
    xledger_id_not_found: XLedger sin prosjekt ID er ikke satt for dette kraftverket
    yearly_production: Årlig produksjon
